export default {

    getData(groupId, status, rawProducts, pack) {
        const skus = pack ? this.getSkusPack(groupId, pack) : this.getSkus(groupId, rawProducts);
        if(!skus.length) {
            return null;
        }
        return {
            id: groupId,
            status: status,
            hasStock: pack ? pack.hasStock : this.hasStock(skus),
            skus: skus,
            otherSkus: pack ? [] : this.getOtherSkus(groupId, rawProducts),
        };
    },   

    getSkus(groupId, products){
        let skus = [];

        products.forEach(el => {
            if(el.relativeGroupId == groupId){
                skus.push(this.formatRow(groupId, el));
            }
        });
        return skus;
    },

    getSkusPack(groupId, pack){
        let temp = [];
        
        if(pack && pack.hasOwnProperty('sku') && pack.hasOwnProperty('hasStock')){
            temp.push({
                'id': groupId,
                'sku': pack.sku,
                'hasStock': pack.hasStock,
                'lastUnits': 0,
            });
        }

        return temp;
    },

    getOtherSkus(groupId, products){
        let temp = [];
        
        products.forEach(el => {
            let id = el.relativeGroupId;    
            if(id !== groupId){
                temp.push(this.formatRow(id, el));
            }
        });

        return temp;
    },

    hasStock(skus){
        let val = false;
        skus.forEach(el => {
            if(el.hasStock === true){
                return true;
            }
        });
        return val;
    },

    formatRow(id, el){
        return {
            'id': id,
            'sku': el.sku,
            'hasStock': el.stock ? true : false,
            'lastUnits': el.stock && el.isLastUnits ? el.stock : 0,
        };
    }
};